"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JilResponseError = exports.getJilFetch = exports.useJilFetch = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const fetch_1 = require("@pandora/fetch");

const react_auth_provider_1 = require("@pandora/react-auth-provider");

const react_env_provider_1 = require("@pandora/react-env-provider");

const react_fetch_provider_1 = require("@pandora/react-fetch-provider");

const react_1 = require("react");
/**
 * Using surrounding React Hooks and Providers for input data, returns an JilFetchInterface.
 * @returns an appropriate JilFetchInterface
 */


const useJilFetch = () => {
  const providedfetch = react_fetch_provider_1.useFetch();
  const authData = react_auth_provider_1.useAuth();
  const env = react_env_provider_1.useEnv();
  const jilFetch = react_1.useMemo(() => exports.getJilFetch({
    accessToken: authData.getAccessToken(),
    env,
    fetch: providedfetch
  }), [authData, env, providedfetch]);
  return jilFetch;
};

exports.useJilFetch = useJilFetch;
/**
 * Given various passed-in options, returns an JilFetchInterface.
 * To be used by the package's hooks and external non-Hook clients to generate the fetch required by APIs.
 * @param jilFetchOptions - The options to be passed in
 * @returns an appropriate JilFetchInterface
 */

const getJilFetch = jilFetchOptions => {
  const baseUrl = getJilBaseUrl(jilFetchOptions.env);
  return (path, params, options) => __awaiter(void 0, void 0, void 0, function* () {
    const fetchLib = jilFetchOptions.fetch || fetch_1.fetch;
    const url = generateUrl(baseUrl, path, params);
    const mergedOptions = Object.assign(Object.assign({}, options), {
      headers: Object.assign(Object.assign({
        Authorization: `Bearer ${jilFetchOptions.accessToken}`
      }, jilFetchOptions.apiKey && {
        'X-Api-Key': jilFetchOptions.apiKey
      }), options === null || options === void 0 ? void 0 : options.headers)
    });
    const response = yield fetchLib(url, mergedOptions);
    checkStatus(response);
    return response;
  });
};

exports.getJilFetch = getJilFetch;

const checkStatus = response => {
  if (response.ok) {
    return response;
  }

  throw new JilResponseError(response);
};

const convertToSearchParams = params => {
  return new URLSearchParams(params);
};

const generateUrl = (baseUrl, path, params) => {
  const myUrl = new URL(path, baseUrl);

  if (params) {
    myUrl.search = convertToSearchParams(params).toString();
  }

  return myUrl.toString();
};

const getJilBaseUrl = env => {
  switch (env) {
    case 'production':
      return 'https://bps-il.adobe.io/jil-api/v2/';

    case 'stage':
      return 'https://bps-il-stage.adobe.io/jil-api/v2/';

    default:
      return 'https://bps-il-int1.adobe.io/jil-api/v2/';
  }
};

class JilResponseError extends Error {
  constructor(response) {
    super(`HTTP Error Response: ${response.status} ${response.statusText}`);
    this.response = response;
  }

}

exports.JilResponseError = JilResponseError;